import { render, staticRenderFns } from "./OrticFormGroup.vue?vue&type=template&id=63673938"
import script from "./OrticFormGroup.vue?vue&type=script&lang=js"
export * from "./OrticFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports